module.exports = __webpack_public_path__ + "static/img/brees-2019-slide-4.8711c0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-slide-4.jpg
// module id = MlwJ
// module chunks = 1